import { Route } from "../types/zod";

/**
 * Routes drawn faintly behind the selected route. Empty when the map owner has
 * turned off `showInactiveRoutes`. Maps saved before the setting existed have no
 * value and keep showing them.
 */
export function getBackgroundRoutes(routes: Route[], selectedRouteId: string, showInactiveRoutes: boolean | undefined): Route[] {
	if (showInactiveRoutes === false) return [];
	return routes.filter(route => route.id != selectedRouteId && route.properties.hideRoute !== true);
}
